import React, { useContext } from 'react';
import { useIsTouchableDevice } from '@philips-internal/oswald-ui-components';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { FoundationApplicationContext } from '../../../context/index.js';
function ApplicationBarTitle(props) {
    const applicationContext = useContext(FoundationApplicationContext);
    const { applicationTitle, module } = props;
    const isTouchableDevice = useIsTouchableDevice();
    let badge;
    let value = applicationTitle;
    if (isTouchableDevice && module) {
        const moduleInformation = applicationContext.getAdditionalModuleInformation(module.id);
        badge = moduleInformation?.badge;
        value = module.name;
    }
    return (React.createElement("div", { className: "c-application-bar__title", "data-badge": badge }, MessageService.translate(value)));
}
export { ApplicationBarTitle, };
//# sourceMappingURL=application-bar-title.js.map